exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".kubernetes-manifest-entry {\n  resize: vertical;\n}\n.kubernetes-manifest-yaml-error-message {\n  display: none;\n}\n.kubernetes-manifest-error .kubernetes-manifest-yaml-error-message {\n  display: block;\n  position: absolute;\n  width: 200px;\n  padding: 0.2em 1em;\n  left: 50%;\n  margin-left: calc(-100.5px);\n  background: red;\n  color: white;\n}\n.kubernetes-manifest-error .kubernetes-manifest-entry {\n  background: #ffdcdc;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist/cjs.js!./app/scripts/modules/kubernetes/src/v2/manifest/wizard/manifestEntry.less
// module id = 3854
// module chunks = 0